module.exports = __webpack_public_path__ + "static/media/salesforce-duplication-rule.83c60ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salesforce-duplication-rule.png
// module id = 593
// module chunks = 1